import Home from './Home';
import { siteTitle } from '../';

const HomeRoutes = {
		home: {
				path: '/',
				label: 'Home',
				title: `${siteTitle} - Home`,
				component: Home
		}
};

export { HomeRoutes, Home };



// WEBPACK FOOTER //
// ./src/app/containers/Home/index.ts